import { render, staticRenderFns } from "./MonitoringLayout.vue?vue&type=template&id=bed17afa"
import script from "./MonitoringLayout.vue?vue&type=script&lang=js"
export * from "./MonitoringLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports